/** Sur un appareil « PDA stock », toute page hors stock renvoie au Mode Stock (démarrage compris). */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { canManageDevices, pdaRedirectFor } from '@/features/pda/pdaAccess';
import { useDeviceRole } from '@/features/pda/useDeviceRole';

export function PdaRouteGuard({ children }: { children: ReactNode }) {
  const { isPda } = useDeviceRole();
  const { userRole } = useAuth();
  const { pathname } = useLocation();
  if (!isPda) return <>{children}</>;
  const target = pdaRedirectFor(pathname, canManageDevices(userRole));
  return target ? <Navigate to={target} replace /> : <>{children}</>;
}
